<h1 class="title">Edit</h1>
<app-add-item-form [item]="item" (formSubmit) = "onSubmitted($event)"></app-add-item-form>